import * as yup from 'yup';
import { Row, RenderConfig, TextInput } from 'commons-ui';

const FORM_FIELD_KEYS = {
	CRM_ALIAS_NAME: 'crmAliasName',
	FRESHDESK_TICKET_ID: 'freshdeskTicketId'
};

export const validationSchema = yup.object().shape({
	crmAliasName: yup.string().required('crmAliasName is a required field'),
	freshdeskTicketId: yup
		.string()
		.required('Freshdesk TicketId is a required field, If no Freshdesk Ticket exists then please use Jira Ticket ID')
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.CRM_ALIAS_NAME]: new RenderConfig()
		.setName('crmAliasName')
		.setLabel('CRM Alias Name')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		}),
	[FORM_FIELD_KEYS.FRESHDESK_TICKET_ID]: new RenderConfig()
		.setName('freshdeskTicketId')
		.setLabel('Freshdesk Ticket Id')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.CRM_ALIAS_NAME), new Row(FORM_FIELD_KEYS.FRESHDESK_TICKET_ID)];
